import { 
  Typography, 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper,
  Divider 
} from '@mui/material';
import CodeBlock from '../../CodeBlock';

function EchoService() {
  return (
    <Box sx={{ textAlign: 'left', maxWidth: '900px' }}>
      <Typography variant="subtitle1" gutterBottom color="text.secondary">
        EUDR SOAP Version 1.3 - REST API Implementation
      </Typography>

      <Typography variant="body1" paragraph sx={{ my: 3 }}>
        Connectivity verification endpoint with enterprise-grade security requirements.
        Validates both API availability and authentication pipeline integrity. <br />
        This endpoint is working with both GET and POST methods, so you can test it with both.
      </Typography>

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Base Endpoints
      </Typography>
      <CodeBlock code="GET /api/eudr/echo?message=Hello EUDR API" />
      <CodeBlock code="POST /api/eudr/echo" />

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Request Requirements 
      </Typography> 
      <Typography variant="subtitle1" gutterBottom>
        Mandatory Fields:
      </Typography>
      <ul>
        <li>Authorization header with valid API token</li>
        <li>Message field in request body (256 character limit)</li>
      </ul>

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Example Request Body (<small>POST</small>)
      </Typography>
      <CodeBlock 
        code={`{
  "message": "Hello EUDR API" 
}`} 
      />

      <Divider sx={{ my: 4 }} />

      <Typography variant="h5" gutterBottom sx={{ mb: 2 }} fontWeight="500">
        Response Handling
      </Typography>
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Code</TableCell>
              <TableCell>Condition</TableCell>
              <TableCell>Resolution</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>200</TableCell>
              <TableCell>Success - Connectivity OK</TableCell>
              <TableCell>No action required</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>408</TableCell>
              <TableCell>Timestamp window expired</TableCell>
              <TableCell>Generate new timestamp</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>401</TableCell>
              <TableCell>Invalid security headers</TableCell>
              <TableCell>Verify API key and headers</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="body1" paragraph sx={{ mt: 3, fontStyle: 'italic' }}>
        Note: Sustained response times over 1s indicate system load issues - 
        reduce request frequency or contact support.
      </Typography>

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Authentication
      </Typography>
      <CodeBlock code="Authorization: Bearer your-api-key-here" />
      <Typography variant="body1" paragraph sx={{ mt: 2 }}>
        Security mechanisms are automatically handled by the API gateway.
      </Typography>
    </Box>
  );
}

export default EchoService; 